import { Empty, Spin } from 'antd';
import download from 'downloadjs';
import moment from 'moment';
import React, { useState } from 'react';
import { BsCloudDownload } from 'react-icons/bs';
import { useDispatch, useSelector } from 'react-redux';
import { v4 as uuidv4 } from 'uuid';
import Apis from '../../../../../../api';
import { RootState } from '../../../../../../store/rootReducer';
import MessageActions from '../../../../../message/redux/actions';
import { ExecutedAgreements } from '../../../redux/types';

const ExecutedAgreementsMobile: React.FC = () => {
    const dispatch = useDispatch();

    const list = useSelector((state: RootState) => state.investments.executedAgreementsDoc);
    const loading = useSelector((state: RootState) => state.investments.eloading);
    const [downloadloading, setLoading] = useState<string | undefined>(undefined);

    const downloadDoc = (row: ExecutedAgreements) => {
        if (row.bookingUUID) {
            setLoading(row.uuid);
            Apis.downloadExecuteOrUpdateDoc(row.bookingUUID, row.uuid)
                .then((res) => {
                    download(
                        new Blob([res.data], { type: res.headers['content-type'] }),
                        row.title,
                        res.headers['content-type'],
                    );
                })
                .catch((err) => {
                    dispatch(MessageActions.showMessage({ text: String(err), error: true }));
                })
                .finally(() => {
                    setLoading(undefined);
                });
        } else if (row.dealUUID) {
            setLoading(row.uuid);
            Apis.downloadDataRoomDocument(
                row.dealUUID,
                row.dealDocParentUUID || row.uuid,
                row.uuid,
                'ExecutedAgreements',
            )
                .then((res1) => {
                    download(
                        new Blob([res1.data], { type: res1.headers['content-type'] }),
                        row.title,
                        res1.headers['content-type'],
                    );
                })
                .catch((err) => {
                    dispatch(MessageActions.showMessage({ error: true, text: String(err) }));
                })
                .finally(() => {
                    setLoading(undefined);
                });
        }
    };
    return (
        <div className="w-full">
            {!loading && list.length === 0 && (
                <Empty description={`No Executed Agreements`} image={Empty.PRESENTED_IMAGE_SIMPLE} />
            )}
            {!loading &&
                list.map((item, index) => (
                    <div
                        className="px-4 py-2 mb-4"
                        style={{ backgroundColor: '#F5F6FF' }}
                        key={`${item.uuid}_${uuidv4()}_${index}`}
                    >
                        <div className="flex flex-wrap">
                            <div className="w-full p-1 pt-4 flex justify-between ">
                                <div>
                                    <p className="font-bold text-xs WorkSans text-[#182D4F]">Title</p>
                                    <p className="text-xs font-normal text-[#20222B]">{item.title}</p>
                                </div>
                                <div>
                                    {item.uuid ? (
                                        downloadloading === item.uuid ? (
                                            <Spin size="small" className="ml-2" />
                                        ) : (
                                            <BsCloudDownload
                                                size={'1.2rem'}
                                                onClick={() => {
                                                    if (!downloadloading) downloadDoc(item);
                                                }}
                                            />
                                        )
                                    ) : (
                                        ''
                                    )}
                                </div>
                            </div>
                            <div className="w-1/2 p-1 pt-4">
                                <p className="font-bold text-xs WorkSans text-[#182D4F]">Issuer</p>
                                <p className="text-xs font-normal text-[#20222B]">{item.issuerName}</p>
                            </div>
                            <div className="w-1/2 p-1 pt-4">
                                <p className="font-bold text-xs WorkSans text-[#182D4F]">Updated On</p>
                                <p className="text-xs font-normal text-[#20222B]">
                                    {item.audit?.updatedAt
                                        ? moment(item.audit.updatedAt).format('DD/MM/YYYY HH:mm:ss')
                                        : ''}
                                </p>
                            </div>
                        </div>
                    </div>
                ))}
            {loading && (
                <div className="flex justify-center items-center py-6">
                    <Spin />
                </div>
            )}
        </div>
    );
};

export default ExecutedAgreementsMobile;
